import { Component, OnInit } from "@angular/core";
import { NavigationEnd, Router, RouterOutlet } from "@angular/router";

import { GtmService } from "@services/google-tag-manager.service";
import { ScriptLoaderService } from "@services/script-loader.service";
import { SearchService } from "@services/search.service";

import { PlantsBannerComponent } from "./layout/banner/plants-banner.component";
import { PlantsFooterComponent } from "./layout/footer/plants-footer.component";
import { PlantsHeaderComponent } from "./layout/header/plants-header.component";
import { BreadcrumbsComponent } from "./shared/breadcrumbs/breadcrumbs.component";
import { LoadingSpinnerComponent } from "./shared/loading-spinner/loading-spinner.component";
import { SidebarMenuComponent } from "./sidebar-menu/sidebar-menu.component";

@Component({
  selector: "plants-app",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  imports: [
    RouterOutlet,
    BreadcrumbsComponent,
    LoadingSpinnerComponent,
    PlantsBannerComponent,
    PlantsFooterComponent,
    PlantsHeaderComponent,
    SidebarMenuComponent
  ]
})
export class AppComponent implements OnInit {
  isShowingSearchResults: boolean;
  isWaitingForSearchResults = false;
  isHomePage: boolean;
  isPlantProfilePage: boolean;

  constructor(
    private gtmService: GtmService,
    private router: Router,
    private scriptLoader: ScriptLoaderService,
    private searchService: SearchService
  ) {}

  ngOnInit(): void {
    this.gtmService.loadGtm();
    this.scriptLoader
      .loadScript("assets/js/uswds.min.js")
      .then(() => {
        document.querySelector("html").classList.remove("usa-js-loading");
      })
      .catch((err) => console.error(err));

    this.searchService.searchStatusUpdated$.subscribe(this.updateSearchStatus.bind(this));

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isHomePage = event.urlAfterRedirects === "/";
        this.isShowingSearchResults = event.url.includes("search-results");
        this.isPlantProfilePage = event.url.includes("plant-profile");
      }
    });
  }

  updateSearchStatus(isWaitingForSearchResults: boolean) {
    this.isWaitingForSearchResults = isWaitingForSearchResults;
  }
}
